import { Task } from '../../../../../../clients/quipli-service/job-tasks/job-tasks';
import Icon from '../../../../../../components/icons/icon';
import { Typography } from '../../../../../../components/typography/typography';
import { OrderMedia } from '../../../../../../clients/quipli-service/order/order';
import { MediaCard } from '../../../../../order/view/order-media-list';

/**
 * Checklist section (to display on the order page)
 * @param checklistTask - The checklist task.
 * @param mediaList - The media list.
 * @param fetch - The function to fetch the media.
 */
export const ChecklistSection = ({
  checklistTask,
  mediaList,
  fetch,
}: {
  checklistTask: Task;
  mediaList: OrderMedia[];
  fetch: () => void;
}) => {
  return (
    <div className="divider-top">
      <p className="text-sm font-semibold">{checklistTask.header}</p>
      {checklistTask.metadata?.checklist.map((item: any) => (
        <>
          <div className="flex items-center justify-between mt-2">
            <Typography type="text-sm">{item.text}</Typography>
            {item.value === undefined ? (
              <p className="text-sm text-grey-500">Pending</p>
            ) : item.value === false ? (
              <div className="flex gap-1 items-center">
                <Icon icon="X" size="small" stroke="red" />
                <p className="m-0 text-sm text-red-500">Not Passed</p>
              </div>
            ) : (
              <div className="flex gap-1 items-center">
                <Icon icon="Check" stroke="green" />
                <p className="m-0 text-sm text-green-500">Passed</p>
              </div>
            )}
          </div>
          {item.notes && <p className="text-sm ml-4 my-0 text-grey-500">{item.notes}</p>}
          {item.media && item.media.length > 0 && (
            <div className="overflow-x-auto flex gap-2 mt-2 pb-4">
              {item.media.map((id: any) => {
                const media = mediaList.find((media) => media.id === id);
                if (!media) return <></>;
                return <MediaCard key={id} media={media!} reload={fetch} enableControls={true} />;
              })}
            </div>
          )}
        </>
      ))}
    </div>
  );
};
